import { useMemo } from 'react'
import * as React from 'react'
import styled from 'styled-components'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vOffset?: number | string
}

const Anchor = styled.div`
  position: relative;
  inset-inline-start: 0;
`

const ScrollAnchor = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { vOffset = 0, ...rest } = props
  const style = useMemo(() => ({ top: `-${vOffset}` }), [vOffset])

  return (
    <Anchor {...rest} style={style} ref={ref} />
  )
})

export default ScrollAnchor
